import { render, staticRenderFns } from "./deleteSender.vue?vue&type=template&id=49cbda0a&"
import script from "./deleteSender.vue?vue&type=script&lang=js&"
export * from "./deleteSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports